var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcEvsePort2 = function SvgIcEvsePort2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_428_230",
    "data-name": "Component 428 \\u2013 230",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.12,
    height: 16.715,
    viewBox: "0 0 26.12 16.715",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_ev_station_24px",
    d: "M21.2,7.6l.011-.011L17.156,3.545,16,4.7l2.3,2.295a2.714,2.714,0,0,0,.971,5.253,2.8,2.8,0,0,0,1.091-.228v5.253a1.091,1.091,0,0,1-2.182,0V14.965A2.185,2.185,0,0,0,16,12.79H14.909v1.631h1.636v2.849a2.727,2.727,0,0,0,5.454,0V9.527A2.717,2.717,0,0,0,21.2,7.6Zm-1.931,3.013a1.088,1.088,0,1,1,1.091-1.088A1.092,1.092,0,0,1,19.272,10.615Z",
    transform: "translate(4.121 -3.545)",
    fill: "#25556e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ic_ev_station_24px-2",
    "data-name": "ic_ev_station_24px",
    d: "M15.705,7.6l-.011-.011,4.058-4.046L20.908,4.7l-2.3,2.295a2.714,2.714,0,0,1-.971,5.253,2.8,2.8,0,0,1-1.091-.228v5.253a1.091,1.091,0,0,0,2.182,0V14.965a2.185,2.185,0,0,1,2.182-2.175H22v1.631H20.363v2.849a2.727,2.727,0,0,1-5.454,0V9.527A2.717,2.717,0,0,1,15.705,7.6Zm1.931,3.013a1.088,1.088,0,1,0-1.091-1.088A1.092,1.092,0,0,0,17.636,10.615Z",
    transform: "translate(-14.909 -3.545)",
    fill: "#25556e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_43",
    "data-name": "Exclusion 43",
    d: "M8,16.645H4V14.727H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0h8a2,2,0,0,1,2,2V12.727a2,2,0,0,1-2,2H8v1.917ZM6.657,2.793,3.6,8.506H5.129v3.428L8.185,6.6H6.657Z",
    transform: "translate(7.08 0.07)",
    fill: "#25556e"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcEvsePort2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_evse_port2.2eb9c7c130453df045403e5ca396b5cc.svg";